var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8599 1.37002L1.29563 57.9343C0.187625 59.0423 0.973645 60.9456 2.54286 60.9456H59.1071C60.0813 60.9456 60.8711 60.1558 60.8711 59.1817V2.61738C60.8712 1.05039 58.9695 0.260491 57.8599 1.37002ZM57.3433 57.4177H6.80153L15.7727 48.4466L18.2297 50.9036C18.5742 51.2481 19.0256 51.4202 19.477 51.4202C21.0344 51.4202 21.8387 49.5234 20.7242 48.4089L18.2671 45.952L23.2988 40.9203L25.7558 43.3774C26.1003 43.7218 26.5517 43.894 27.0031 43.894C28.5605 43.894 29.3648 41.9972 28.2503 40.8827L25.7934 38.4257L30.825 33.3941L33.2821 35.8512C33.6265 36.1956 34.078 36.3678 34.5293 36.3678C36.0868 36.3678 36.891 34.4709 35.7765 33.3565L33.3196 30.8995L38.3512 25.8679L40.8083 28.325C41.1527 28.6694 41.6042 28.8416 42.0555 28.8416C43.613 28.8416 44.4172 26.9447 43.3028 25.8302L40.8458 23.3733L45.8774 18.3417L48.3345 20.7987C48.679 21.1432 49.1304 21.3153 49.5818 21.3153C51.1392 21.3153 51.9435 19.4185 50.829 18.304L48.372 15.8471L57.3432 6.87592V57.4177H57.3433Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4509 30.5331L30.4577 46.5263C29.3497 47.6343 30.1358 49.5376 31.705 49.5376H47.6982C48.6723 49.5376 49.4621 48.7478 49.4621 47.7737V31.7805C49.4622 30.2135 47.5606 29.4236 46.4509 30.5331ZM45.9343 46.0097H35.9636L45.9343 36.039V46.0097Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAngle);
export default __webpack_public_path__ + "static/media/right_angle.f87c11d22694f536d98920b895709beb.svg";
export { ForwardRef as ReactComponent };